export const OfficeAccessoriesLiveCreateState = {
	url: '/accessories/create/:bu_id/:prod_id',
	title: 'Office Live Accessories - Create',
	template: '<office-accessories-create-live></office-accessories-create-live>',
	params: {
		prod_id: null,
		bu_id: null,
	},
	lazyLoad: $transition$ => {
		const $ocLazyLoad = $transition$.injector().get('$ocLazyLoad');
		const $log = $transition$.injector().get('$log');
		return import(
			/* webpackChunkName: "officeAccessoriesLiveCreatePageMod" */
			'@Containers/office-accessories-page/live-create/live-create.cmp.js'
		)
			.then(res => $ocLazyLoad.load({name: res.default}))
			.catch(err => $log.error(err));
	},
};
